import {
	DocNodeSpec,
	ParagraphNodeSpec,
	TextNodeSpec,
	HeadingNodeSpec,
	SelectionMarkSpec,
	BreakNodeSpec,
	DOC_KEY,
	PARAGRAPH_KEY,
	TEXT_KEY,
	HEADING_KEY,
	SELECTION_KEY,
	BREAK_KEY
} from '@techchange/pm-specs';

import coreKeymap from './plugins/keymap';
import placeholder from './plugins/placeholder';

const core = {

	nodes() {

		return {
			[DOC_KEY]: DocNodeSpec,
			[PARAGRAPH_KEY]: ParagraphNodeSpec,
			[TEXT_KEY]: TextNodeSpec,
			[HEADING_KEY]: HeadingNodeSpec,
			[BREAK_KEY]: BreakNodeSpec,
		};

	},

	marks() {

		return {
			[SELECTION_KEY]: SelectionMarkSpec,
		};

	},

	plugins(options) {

		return [coreKeymap, placeholder(options.placeholderText)];

	},

};

export default core;
